import { CheckboxProps } from "../checkbox/CheckboxProps";
import { HeadingTableCell } from "./HeadingTableCell";
import { SelectCheckboxTableCellMixin } from "./SelectCheckboxTableCellMixin";

export class SelectCheckboxHeadingTableCell extends SelectCheckboxTableCellMixin(HeadingTableCell) {
    protected override createCheckbox() {
        super.createCheckbox();
        this.checkbox.addChangeListener(this.table.selectCheckboxHandler.checkboxSelectAllOnChange);
    }

    protected get addlCheckboxProps(): Partial<CheckboxProps> {
        return {
            id: "checkboxSelectAllRows",
            enabled: false, // Disable checkbox until records are present
            marginTop: -2
        };
    }
}
